import {
  Card,
  FormLayout,
  Layout,
  Loading,
  SkeletonBodyText,
  SkeletonPage,
  TextContainer
} from "@shopify/polaris";
import { CsI18n } from "../../shared/csI18n/csI18n";
import React from "react";

const CompanySkeleton = () => {
  return (
    <SkeletonPage title={CsI18n.t("My Company")} fullWidth>
      <Loading />
      <Layout>
        <Layout.AnnotatedSection title={CsI18n.t("company.annotate.title.website")}
                                 description={CsI18n.t("company.annotate.desc.website")}>
          <Layout.Section>
            <Card sectioned>
              <FormLayout>
                <TextContainer>
                  <SkeletonBodyText lines={6} />
                </TextContainer>
              </FormLayout>
            </Card>
          </Layout.Section>
        </Layout.AnnotatedSection>
        <Layout.AnnotatedSection title={CsI18n.t("company.annotate.title.legal_info")}
                                 description={CsI18n.t("company.annotate.desc.legal_info")}>
          <Layout.Section>
            <Card sectioned>
              <FormLayout>
                <TextContainer>
                  <SkeletonBodyText lines={6} />
                </TextContainer>
              </FormLayout>
            </Card>
          </Layout.Section>
        </Layout.AnnotatedSection>
        <Layout.AnnotatedSection title={CsI18n.t("company.annotate.title.address")}
                                 description={CsI18n.t("company.annotate.desc.address")}>
          <Layout.Section>
            <Card sectioned>
              <FormLayout>
                <TextContainer>
                  <SkeletonBodyText lines={6} />
                </TextContainer>
              </FormLayout>
            </Card>
          </Layout.Section>
        </Layout.AnnotatedSection>
        <Layout.AnnotatedSection title={CsI18n.t("company.annotate.title.payment")}
                                 description={CsI18n.t("company.annotate.desc.payment")}>
          <Layout.Section>
            <Card sectioned>
              <FormLayout>
                <TextContainer>
                  <SkeletonBodyText lines={6} />
                </TextContainer>
              </FormLayout>
            </Card>
          </Layout.Section>
        </Layout.AnnotatedSection>
        <Layout.AnnotatedSection title={CsI18n.t("company.annotate.title.marketplaces")}
                                 description={CsI18n.t("company.annotate.desc.marketplaces")}>
          <Layout.Section>
            <Card sectioned>
              <FormLayout>
                <TextContainer>
                  <SkeletonBodyText lines={6} />
                </TextContainer>
              </FormLayout>
            </Card>
          </Layout.Section>
        </Layout.AnnotatedSection>
        <Layout.AnnotatedSection title={CsI18n.t('company.annotate.title.customer_service')}
                                 description={CsI18n.t("company.annotate.desc.customer_service")}>
          <Layout.Section>
            <Card sectioned>
              <FormLayout>
                <TextContainer>
                  <SkeletonBodyText lines={6} />
                </TextContainer>
              </FormLayout>
            </Card>
          </Layout.Section>
        </Layout.AnnotatedSection>
        <Layout.AnnotatedSection title={CsI18n.t('company.annotate.title.mediation')}
                                 description={CsI18n.t("company.annotate.desc.mediation")}>
          <Layout.Section>
            <Card sectioned>
              <FormLayout>
                <TextContainer>
                  <SkeletonBodyText lines={6} />
                </TextContainer>
              </FormLayout>
            </Card>
          </Layout.Section>
        </Layout.AnnotatedSection>
      </Layout>
    </SkeletonPage>
  )
};

export default CompanySkeleton;
